import { Dispatch } from 'react';
import { renderItemContentForItemsWithIdName } from '../../../routes/Settings/rules-v3/rules.utils';
import {
  MCustomMultiSelect,
  MCustomMultiSelectProps,
} from '../MCustomSelect/MCustomMultiSelect';

interface SelectProps {
  value: string[];
  setValue: Dispatch<any>;
  extraProps?: MCustomMultiSelectProps;
}

export const LegalEntityDropdownMultiSelect = ({
  value,
  setValue,
  extraProps,
}: SelectProps) => {
  return (
    <MCustomMultiSelect
      showQueryInput
      closeButtonText="Apply"
      endpoint="/api/configurations/legalEntities"
      loadAll
      itemTitle="name"
      itemValue="id"
      renderItemContent={renderItemContentForItemsWithIdName}
      value={value ?? []}
      onChange={(newValue: any) => setValue(newValue)}
      isLazy
      multiple
      placeholder="Select Legal Entities"
      clearable
      onClear={() => setValue([])}
      {...extraProps}
    />
  );
};
